import store from '@/store'
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'

type TenantAdminContext = {
  to: RouteLocationNormalized
  next: NavigationGuardNext
  from: RouteLocationNormalized
}

const tenantAdmin = async ({ to, next, from }: TenantAdminContext): Promise<void> => {
  const isAuth = localStorage.getItem('token')

  if (!isAuth) {
    sessionStorage.setItem('userRequestUrl', JSON.stringify({ name: to.name, query: to.query, params: to.params }))
    return next({ name: 'login' })
  }

  if (!(store as any).state.user.currentUser) {
    await (store as any).dispatch('user/getCurrentUserAccount')
  }

  if ((store as any).state.user.currentUser?.administratedTenants?.includes(to.params.tenant)) {
    return next()
  }

  return next(from)
}

export default tenantAdmin
